export const TEST = {
  LOADING: 'TEST_LOADING',
  GET_TEST_SUCCESS: 'GET_TEST_SUCCESS',
  ERROR: 'TEST_ERROR',
  CLEAR: 'TEST_CLEAR'
}

const initialState = {
  loading: false,
  data: null,
  error: null,
  resultData: null // Add result data to state
};

export const testReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEST.LOADING:
      return { ...state, loading: true, error: false }
    case TEST.GET_TEST_SUCCESS:
      return { 
        ...state, 
        data: action.payload,
        loading: false,
        error: false
      }
    case TEST.ERROR:
      return { 
        ...state, 
        error: action.payload, 
        loading: false 
      }
    case TEST.CLEAR:
      return { 
        ...state, 
        data: null,
        error: false 
      }
    case 'SET_RESULT_DATA':
      return {
        ...state,
        resultData: action.payload
      };
      
    case 'CLEAR_RESULT_DATA':
      return {
        ...state,
        resultData: null
      };
      
    default:
      return state;
  }
}; 